import React from 'react';

import { AttributionRole, AttributionRoleLabels } from '../../../@types/CoproUserAttribution';
import Popup from '../../common/Popup/Popup.module';

interface RolesDemoPopupProps {
  isOpen: boolean;
  onClose: () => void;
  selectedRoles: string[];
  onChange: (roles: string[]) => void;
}

const ALL_ROLES: { label: string; value: string }[] = [
  { label: 'Dirigeant', value: 'dirigeant' },
  { label: AttributionRoleLabels[AttributionRole.REFERENT], value: AttributionRole.REFERENT },
  { label: AttributionRoleLabels[AttributionRole.ASSISTANT_REFERENT], value: AttributionRole.ASSISTANT_REFERENT },
  { label: AttributionRoleLabels[AttributionRole.GESTIONNAIRE], value: AttributionRole.GESTIONNAIRE },
  { label: AttributionRoleLabels[AttributionRole.ASSISTANT_GESTIONNAIRE], value: AttributionRole.ASSISTANT_GESTIONNAIRE },
  { label: AttributionRoleLabels[AttributionRole.TRANSACTIONNAIRE], value: AttributionRole.TRANSACTIONNAIRE },
  { label: AttributionRoleLabels[AttributionRole.GESTIONNAIRE_LOCATIF], value: AttributionRole.GESTIONNAIRE_LOCATIF },
  { label: AttributionRoleLabels[AttributionRole.INTERVENANT], value: AttributionRole.INTERVENANT },
];

function RolesDemoPopup({ isOpen, onClose, selectedRoles, onChange }: RolesDemoPopupProps) {
  const toggleRole = (role: string) => {
    if (selectedRoles.includes(role)) {
      onChange(selectedRoles.filter((r) => r !== role));
    } else {
      onChange([...selectedRoles, role]);
    }
  };

  const selectAll = () => onChange(ALL_ROLES.map((r) => r.value));
  const clearAll = () => onChange([]);

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      title={(
        <div className="flex items-center gap-2">
          <span>Configuration de la démo des rôles</span>
        </div>
      )}
      maxWidth="680px"
      width="680px"
    >
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          <button
            type="button"
            className="rounded-md bg-gray-100 px-3 py-1.5 text-sm text-gray-800 hover:bg-gray-200"
            onClick={selectAll}
          >
            Tout sélectionner
          </button>
          <button
            type="button"
            className="rounded-md bg-gray-100 px-3 py-1.5 text-sm text-gray-800 hover:bg-gray-200"
            onClick={clearAll}
          >
            Tout désélectionner
          </button>
        </div>

        <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
          {ALL_ROLES.map((role) => {
            const enabled = selectedRoles.includes(role.value);
            return (
              <label
                key={role.value}
                className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-3"
              >
                <span className="text-sm font-medium text-gray-800">{role.label}</span>
                <button
                  type="button"
                  role="switch"
                  aria-checked={enabled}
                  onClick={() => toggleRole(role.value)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${enabled ? 'bg-rgpd-blue' : 'bg-gray-300'}`}
                >
                  <span
                    className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${enabled ? 'translate-x-5' : 'translate-x-1'}`}
                  />
                </button>
              </label>
            );
          })}
        </div>

        <p className="text-xs text-gray-500">
          Astuce: activez le bouton « Afficher la page avec les rôles » pour prévisualiser l'interface avec la sélection ci‑dessus. Aucune donnée n'est modifiée côté serveur.
        </p>
      </div>
    </Popup>
  );
}

export default RolesDemoPopup;


